export default function () {
  return {
    notifications: [],
    loading: false,
  }
}
